import { asEnumValue } from "@opendaw/lib-std";
export var TimeBase;
(function (TimeBase) {
    TimeBase["Musical"] = "musical";
    TimeBase["Seconds"] = "seconds";
})(TimeBase || (TimeBase = {}));
export var TimeBaseConverter;
(function (TimeBaseConverter) {
    function aware(tempoMap, timeBase, property) {
        return new TimeBaseAwareConverter(tempoMap, timeBase, property);
    }
    TimeBaseConverter.aware = aware;
})(TimeBaseConverter || (TimeBaseConverter = {}));
class TimeBaseAwareConverter {
    #tempoMap;
    #timeBase;
    #property;
    constructor(tempoMap, timeBase, property) {
        this.#property = property;
        this.#timeBase = timeBase;
        this.#tempoMap = tempoMap;
    }
    toPPQN(position) {
        const value = this.#property.getValue();
        if (this.getTimeBase() === TimeBase.Musical) {
            return value;
        }
        const startSeconds = this.#tempoMap.ppqnToSeconds(position);
        const endSeconds = startSeconds + value;
        return this.#tempoMap.intervalToPPQN(startSeconds, endSeconds);
    }
    fromPPQN(value, position) {
        if (this.getTimeBase() === TimeBase.Musical) {
            this.#property.setValue(value);
        }
        else {
            const seconds = this.#tempoMap.intervalToSeconds(position, position + value);
            this.#property.setValue(seconds);
        }
    }
    toSeconds(position) {
        const value = this.#property.getValue();
        if (this.getTimeBase() === TimeBase.Seconds) {
            return value;
        }
        return this.#tempoMap.intervalToSeconds(position, position + value);
    }
    toSamples(position, sampleRate) { return this.toSeconds(position) * sampleRate; }
    rawValue() { return this.#property.getValue(); }
    getTimeBase() { return asEnumValue(this.#timeBase.getValue(), TimeBase); }
}
